/** Truthy when user is currently interacting with an input or textarea element */
export function interactingWithInput(): boolean {
  const activeElementTagName = window.document.activeElement?.tagName;
  return activeElementTagName === "INPUT" || activeElementTagName === "TEXTAREA";
}
